<template>
  <div class="loading-doc">
    <h1 class="large-title">Loading State</h1>
    <loading-primary />
    <loading-secondary />
    <h1 class="large-title">Empty State</h1>
    <adx-not-found :title="`Oops, no result found`" :subtitle="`Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore`" />
  </div>
</template>

<script>
import LoadingPrimary from '@/components/Loading/Primary'
import LoadingSecondary from '@/components/Loading/Secondary'
import NotFound from '@/components/NotFound/Saved'

export default {
  name: 'adx-loading-doc',
  components: {
    'loading-primary': LoadingPrimary,
    'loading-secondary': LoadingSecondary,
    'adx-not-found': NotFound
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>